import React, { useState } from 'react';

import PropTypes from 'prop-types'




export default function TextForm(props) {
    const handleUpClick = () => {
        console.log("Uppercase was clicked" + text);
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to Uppercase","Success");
    }
    const handleLoClick = () => {
        console.log("Lowercase was clicked" + text);
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to Lowercase","Success");
    }
    const handleClearClick = () => {
        console.log("Clear was clicked" + text);
        let newText = ('');
        setText(newText);
        props.showAlert("Cleared the text","Success");
    }
    const handleTitleClick = () => {
        let newText = text.split(" ").map((currentValue) => {
            let newText = currentValue[0].toUpperCase() + currentValue.slice(1);
            return newText;
            

        });
        setText(newText.join(" "));
        props.showAlert("Converted to title case","Success");
    }
    const handleExtraSpaces = ()=>{
        let newText = text.replace(/\s+/g, ' ').trim();
        setText(newText);
        props.showAlert("Extra spaces Removed","Success");

        }
        
    const handleOnChange = (event) => {
        console.log("On change");
        setText(event.target.value);
    }
    
    const [text, setText] = useState("");
    return (
        <>
            <div className='container' style={{color:props.mode==='dark'?'white':'#074956'}}>
                <h1 >{props.heading}</h1>
                <div className="mb-3" >

                    <textarea className="form-control" onChange={handleOnChange} id="myBox" rows="8" value={text} style={{backgroundColor:props.mode==='dark'?'grey':'white',color:props.mode==='dark'?'white':'#074956'}}></textarea>
                </div>
                <button className="btn btn-primary mx-2" onClick={handleUpClick} style={{  backgroundColor: "cyan", }}>Convert to Uppercase</button>
                <button className="btn btn-primary mx-2" onClick={handleLoClick} style={{ backgroundColor: "cyan", }}>Convert to Lowercase</button>
                <button className="btn btn-primary mx-2" onClick={handleClearClick} style={{  backgroundColor: "cyan", }}>Clear</button>
                <button className="btn btn-primary mx-2" onClick={handleTitleClick} style={{  backgroundColor: "cyan", }}>Title Case</button>
                <button className="btn btn-primary mx-2" onClick={handleExtraSpaces} style={{  backgroundColor: "cyan", }}>Remove Extra Space </button>

            </div>

            <div className="container" style={{color:props.mode==='dark'?'white':'#074956'}}>
                <h2>Text Summary</h2>
                <p>{text.split(" ").length} words and {text.length}characters</p>
                <p>Time to read {0.008 * text.split(" ").length} minutes </p>
                <h3>Preview</h3>
                <p>{text.length>0?text:"Enter some text to preview it"}</p>
            </div>
        </>
    )

}

// What I learned today from this video are:
// i. Created a new component named Textform and used it in app.js
// ii. Imported and used a 'useState' react hook in order to change the value of text according to the state.
// iii. Created and used two arrow functions for responding to the onClick event of the button and onChange event of the textarea.